'use client';

import { useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ArrivalOrderTabPreview } from './_components/arrival-order-tab-preview.component';
import { SearchCardArrivalOrderModal } from './search-card-arrival-order-modal.component';

import { ArrivalOrderSlotsGrid } from '@/app/(main)/(pages)/_components/schedules/arrival-order/arrival-order-slots-grid.component';
import { SlotsSkeleton } from '@/app/(main)/(pages)/_components/schedules/slots-skeleton.component';
import { useScheduleSlots } from '@/app/(main)/(pages)/_components/schedules/_hooks/use-schedule-slots.hook';
import { useSlotFilters } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-slot-filters.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { sumProcedurePrices } from '@/utils/procedures/procedures.util';

const CARD_ARRIVAL_ORDER_DAYS = 3;

interface SearchCardTabArrivalOrderProps {
  schedule: SearchPartnerData;
  scheduleType?: ScheduleType;
}

export function SearchCardTabArrivalOrder({
  schedule,
  scheduleType = ScheduleType.ARRIVAL_ORDER,
}: SearchCardTabArrivalOrderProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scheduleId = schedule.schedulesTypes[scheduleType]?.[0]?.id;
  const slotFilters = useSlotFilters();

  const { isLoading, days, hasMore, offset, goNext, goPrev } = useScheduleSlots({
    scheduleId,
    limitDays: CARD_ARRIVAL_ORDER_DAYS,
    filters: slotFilters,
  });

  const partnerId = schedule.partner.id;
  const price = sumProcedurePrices(schedule.procedures);
  const openModal = () => setIsModalOpen(true);

  return (
    <div data-testid={DataTestIdEnum.SEARCH_CARD_TAB_ARRIVAL_ORDER}>
      {isLoading
        ? (
            <>
              <SlotsSkeleton variant="card" className="xl:hidden" />
              <SlotsSkeleton variant="modal" columns={CARD_ARRIVAL_ORDER_DAYS} className="hidden xl:flex" />
            </>
          )
        : (
            <>
              <ArrivalOrderTabPreview
                day={days[0]}
                partnerId={partnerId}
                price={price}
                className="xl:hidden"
                onSeeMore={openModal}
              />
              <ArrivalOrderSlotsGrid
                days={days}
                hasMore={hasMore}
                offset={offset}
                partnerId={partnerId}
                price={price}
                className="hidden xl:flex"
                onPrev={goPrev}
                onNext={goNext}
                onSeeMore={openModal}
              />
            </>
          )}

      <SearchCardArrivalOrderModal
        scheduleId={scheduleId}
        schedule={schedule}
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </div>
  );
}
